var featurePositions = ['sw-widget-top-jackpot', 'sw-widget-bottom-jackpot'];

sw_mwjp_widget.tickers = {};
sw_mwjp_widget.tickers.containersMatrix = [];

sw_mwjp_widget.tickers.ticker = function (id, currency, tickerValue, dropAmount, displayName, logo) {
    var featureId = `feature_${id}`;
    let feature = sw_mwjp_widget.main.createElement('div', [["id", featureId], ["class", "feature"]], "", featureId);
    if (feature) {
        // Big text
        let innerText1 = sw_mwjp_widget.main.createElement('div',
            [
                ["class", "widget-innerText__item"],
                ""
            ]);
        if (!logo || logo === "") {
            let bigText = sw_mwjp_widget.main.createElement('span',
                [
                    ["class", "widget-innerText__item--bigtext"]
                ], displayName);

            innerText1.appendChild(bigText);
        } else {
            innerText1.appendChild(sw_mwjp_widget.main.createElement('div',
                [
                    ["class", "widget-innerText__logo"]
                ], `<div><img src=${logo}></div>`));
        }
        feature.appendChild(innerText1);


        // Ticker text
        let innerText2 = sw_mwjp_widget.main.createElement('div',
            [
                ["class", "widget-innerText__item widget-innerText__middle"],
                ["id", `sw_mwjp_ticker${id}`]
            ], "");
        let tickerText = sw_mwjp_widget.main.createElement('div',
            [
                ["class", "widget-innerText__item--ticker"], ["id", `ticker_${id}`], ["tickerValue", tickerValue], ["currency", currency],
                ["style", "width: 100%;"]
            ], "");
        sw_mwjp_widget.tickers.updateTicker(tickerText, sw_mwjp_widget.format.formatNumber(tickerValue, 2), sw_mwjp_widget.format.formatNumber(tickerValue, 2), id);
        innerText2.appendChild(tickerText);
        feature.appendChild(innerText2);


        // Big text
        var html = sw_mwjp_widget.localization.getFormattedString(sw_mwjp_widget.environment.lang, 'dropAmount',
            ['<span class="widget-innerText__item--accent">' + `${currency}${sw_mwjp_widget.format.formatNumber(dropAmount, 0)}` + '</span>']);
        let innerText3 = sw_mwjp_widget.main.createElement('div',
            [
                ["class", "widget-innerText__item"]
            ], "");
        let smalltext = sw_mwjp_widget.main.createElement('span',
            [
                ["class", "widget-innerText__item--smalltext"], ["dropAmount", sw_mwjp_widget.format.formatNumber(dropAmount, 0)], ["currency", currency]
            ], html);

        innerText3.appendChild(smalltext);
        feature.appendChild(innerText3);

        document.getElementById(featurePositions[id]).appendChild(feature);
        sw_mwjp_widget.tickers.animateTicker(tickerText, currency, tickerValue, tickerValue, id);

    } else {
        var ticker = document.getElementById(`ticker_${id}`);
        sw_mwjp_widget.tickers.animateTicker(ticker, currency, Number(ticker.getAttribute("tickerValue")), tickerValue, id);
    }
};


sw_mwjp_widget.tickers.animateTicker = function (ticker, currency, from, to, id) {
    var {speed, increment} = sw_mwjp_widget.tickers.calculateSpeed(ticker, from, to, sw_mwjp_widget.environment.SERVER_DELAY - 200, id);
    if (speed) {
        sw_mwjp_widget.tickers.startInterval(ticker, from, increment, speed, to, id);
    }
    ticker.setAttribute("tickerValue", to);
};

sw_mwjp_widget.tickers.calculateSpeed = function (ticker, from, to, serverDelay, id) {
    if (to < from) {
        sw_mwjp_widget.tickers.updateTicker(ticker, to, to, id);
        return {undefined, undefined};
    }
    var increment = 0.01;
    var speed = 0;
    for (let i = 1; i < 1000; i++) {
        speed = ((serverDelay / 1000) / ((to - from) / increment)) * 1000;
        if (speed >= 10) {
            return {speed, increment};
        }
        increment *= 11;
    }
    return {speed, increment};
};


sw_mwjp_widget.tickers.updateTicker = function (ticker, formatNumber, number, id) {
    formatNumber = sw_mwjp_widget.format.formatNumber(formatNumber, 2);
    number = sw_mwjp_widget.format.formatNumber(number, 2);
    if (sw_mwjp_widget.tickers) {
        formatNumber = ticker.getAttribute("currency") + formatNumber;
        sw_mwjp_widget.tickers.toContainers(ticker, formatNumber, id);
        ticker.setAttribute("formatNumber", number);
    }
};

sw_mwjp_widget.tickers.startInterval = function (ticker, current, increment, stepTime, endValue, id) {
    let cloneCurrent = Number(current);
    if(!sw_mwjp_widget.tickers.intervalId){
        sw_mwjp_widget.tickers.intervalId = [];
    }
    if(sw_mwjp_widget.tickers.intervalId.length > sw_mwjp_widget.environment.featureInstanceIds.length){
        sw_mwjp_widget.tickers.clearIntervals();
    }
    sw_mwjp_widget.tickers.intervalId.push({
        interval: setInterval(() => {
            cloneCurrent += increment;
            cloneCurrent = Number(cloneCurrent);
            if (cloneCurrent > endValue) {
                cloneCurrent = endValue;
            }
            sw_mwjp_widget.tickers.updateTicker(ticker, sw_mwjp_widget.format.formatNumber(cloneCurrent), cloneCurrent, id);

            if (cloneCurrent === endValue) {
                sw_mwjp_widget.tickers.clearIntervals();
            }
        }, stepTime),
        id: id,
        endValue: endValue,
        tickerContainer: ticker
    });
};

sw_mwjp_widget.tickers.clearIntervals = function () {
    if(sw_mwjp_widget.tickers && sw_mwjp_widget.tickers.intervalId) {
        while(sw_mwjp_widget.tickers.intervalId.length !== 0) {
            const interval = sw_mwjp_widget.tickers.intervalId.pop();
            clearInterval(interval.interval);
            sw_mwjp_widget.tickers.updateTicker(interval.tickerContainer, sw_mwjp_widget.format.formatNumber(interval.endValue), interval.endValue, interval.id);
        }
    }
};

sw_mwjp_widget.tickers.toContainers = function (ticker, formatNumber, featureId) {
    let containers = sw_mwjp_widget.tickers.containersMatrix[featureId];
    if (!containers) {
        containers = [];
        sw_mwjp_widget.tickers.containersMatrix[featureId] = containers;
    }
    if (formatNumber.length > containers.length) {
        for (let i = containers.length; i < formatNumber.length; i++) {
            containers[i] = document.createElement("div");
            containers[i].setAttribute("id", `sw_mwjp_widget.ticker-f${featureId}-n${i}`);
            ticker.appendChild(containers[i]);
        }
    } else {
        const leftover = containers.length - formatNumber.length;
        for (let i = 0; i < leftover; i++) {
            containers[containers.length - 1 - i].setAttribute("style", "display: none;");
        }
    }
    for (let i = 0; i < formatNumber.length; i++) {
        let tchar = formatNumber.charAt(i);
        let tclass;
        if (tchar === "." || tchar === ",") {
            tclass = "sw-widget-jackpot-dot";
        } else if (Number.isInteger(Number(tchar))) {
            tclass = "sw-widget-jackpot-number";
        } else {
            tclass = "sw-widget-jackpot-currency";
        }

        containers[i].setAttribute("style", "");
        containers[i].setAttribute("class", tclass);
        containers[i].innerHTML = tchar;
    }
    return containers;
};